import React, { useEffect, useState } from "react";
import AlertBox from "../Utills/AlertBox";
import axios from "axios";
import { withRouter } from "react-router-dom";
import { Trans, withTranslation,useTranslation } from "react-i18next";

const CancelSubscription = ({ history, user_id, active }) => {
  const { t } = useTranslation();
  const [options, setOptions] = useState({
    alert: false,
    head: "",
    message: "",
    success: true,
    action: null,
  });
  const [active_sub, setActive_sub] = useState(true)

  useEffect(()=>{
    if(active){
      setActive_sub(true)
    }else(
      setActive_sub(false)
    )
  },[active])

  const openModal = () => {
    setOptions((prev) => ({
      ...prev,
      alert: true,
      head: t('cancel_subs'),
      message: t('Are you sure you want to cancel subscription and auto renewal'),
      success: true,
      action: () => cancelSubscription(),
    }));
  };

  const cancelSubscription = () => {
    const api_url = localStorage.getItem("api_url");
    const formdata = new FormData();
    formdata.set("user_id", user_id);

    axios({
      method: "post",
      url: api_url + "cancelsubscription",
      data: formdata,
      config: { headers: { "Content-Type": "multipart/form-data" } },
    }).then((res) => {
      const response = res.data;

      if (response.status != true) {
        setActive_sub(false)
        setOptions((prev) => ({
          ...prev,
          alert: true,
          head: "Request Failed",
          message: response.message,
          success: false,
          action: null,
        }));
      } else {
        if (response.subscription == "expired") {
          setTimeout(() => {
            setOptions((prev) => ({
              ...prev,
              alert: true,
              head: "Subscription Cancelled successfully",
              message: response.message,
              success: true,
              action: null,
            }));
            history.push("/nonpremiumpayment");
          }, 3000);
        } else {
          setOptions((prev) => ({
            ...prev,
            alert: true,
            head: "Subscription Cancelled successfully",
            message: response.message,
            success: true,
            action: null,
          }));
          setActive_sub(false)
        }
      }
    });
  };
  return (
    <div className="cancel-sub-container">
      <button
        className={`btn amt20 btn-bg ${
          active_sub ? "cancel-sub-button-active" : "cancel-sub-button-disable"
        }`}
        onClick={openModal}
        disabled={!active_sub}
      >
        {active_sub?t('cancel_subs'):t('cancel_subs')}
      </button>
      <AlertBox options={options} />
    </div>
  );
};

export default CancelSubscription;
